import { useState } from 'react';
import Typography from '@mui/material/Typography';
import { ButtonOne } from '../../ButtonOne/ButtonOne.component';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import { EditSpecialCase } from './EditSpecialCase.component';
import { WorkMode } from './SpecialCases.types';

interface EmptySpecialCaseTable {
  onClose: () => void;
}

export const EmptySpecialCaseTable: React.FC<EmptySpecialCaseTable> = ({ onClose }) => {
  const [isAddSpecialCaseModalOpen, setIsAddSpecialCaseModalOpen] = useState<boolean>(false);

  const noRecipients = {
    domesticCoordinator: false,
    examTaskGroupCoordinator: false,
    examiningTeamChairman: false,
    techAdmin: false,
  };

  return (
    <div
      style={{
        height: '85%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          width: '385px',
        }}
      >
        <CampaignOutlinedIcon style={{ color: '#BCBEDC', width: '70px', height: '70px', margin: '20px' }} />
        <Typography fontSize={18} color={'#3C419A'} fontWeight={'700'}>
          W tej chwili nie został dodany żaden szczególny przypadek.
        </Typography>
        <ButtonOne
          style={{ backgroundColor: '#3C419A', marginTop: '30px' }}
          variant="contained"
          color="secondary"
          onClick={() => setIsAddSpecialCaseModalOpen(true)}
        >
          + DODAJ NOWY SZCZEGÓLNY PRZYPADEK
        </ButtonOne>
        {isAddSpecialCaseModalOpen && (
          <EditSpecialCase
            title={'Dodaj nowy szczególny przypadek'}
            data={{
              id: '',
              title: '',
              description: '',
              domesticCoordinator: false,
              examTaskGroupCoordinator: false,
              examiningTeamChairman: false,
              techAdmin: false,
            }}
            workMode={WorkMode.ADD}
            onCancel={() => {
              setIsAddSpecialCaseModalOpen(false);
            }}
            onClose={() => {
              setIsAddSpecialCaseModalOpen(false);
              onClose();
            }}
          />
        )}
      </div>
    </div>
  );
};
